import Button from "./Button";

export default function PrimaryButton({
  label,
  isFullWidth,
  onClick,
  labelClassName,
  disabled = false,
  'aria-label': ariaLabel
}: {
  label: string
  isFullWidth: boolean
  onClick: () => void
  labelClassName: string
  disabled?: boolean
  'aria-label'?: string
}) {
  return (
    <Button
      disabled={disabled}
      isFullWidth={isFullWidth}
      label={label}
      labelClassName={labelClassName}
      buttonClassName="bg-black text-white h-[56px] text-base font-medium focus:outline-none focus:border-none z-1 relative"
      onClick={onClick}
      aria-label={ariaLabel}
    />
  )
}
